export enum AttachmentMangeAccessLevel {
  None = 'none',
  Owner = 'owner',
  All = 'all'
}



// WEBPACK FOOTER //
// ./src/components/shared/Templates/Maintenance/MaintenanceAttachmentsTile/enum/attachmentMangeAccessLevel.ts